import React, {useEffect, useState} from "react";
import {Bug} from "lucide-react";
import useAnimateElement from "../util/useAnimateElement";
import ErrorUtil from "../../../shared/ErrorUtil";

const indicatorStyle = {
	position: "fixed",
	width: 50,
	height: 50,
	right: 10,
	bottom: 10,
	padding: 5,
	zIndex: 1000000,
	textAlign: "center",
	cursor: "pointer",
} as const;

export const DevErrorIndicator = () => {
	const [showBug, setShowBug] = useState(true);
	const {ref, animate} = useAnimateElement<HTMLDivElement>(
		[{transform: "rotate(15deg)"}, {transform: "rotate(-15deg)"}],
		{
			animateOptions: {
				duration: 1200,
				easing: "ease-in-out",
				direction: "alternate",
				iterations: 5,
				fill: "both",
			},
		}
	);

	const onClick = () => {
		setShowBug(false);
	};

	useEffect(() => {
		animate();
		const listener = (obj: any) => {
			console.log("ERROR LOGGED:", obj); // eslint-disable-line no-console
		};
		ErrorUtil.addListenerAndCallForPrevious(listener);
		return () => {
			ErrorUtil.removeListener(listener);
		};
	}, [animate]);

	if (!showBug) {
		return null;
	}

	return (
		<div
			ref={ref}
			onClick={onClick}
			style={indicatorStyle}
			title="An error occurred! Check the console for details."
			role="button"
			aria-label="An error occurred! Check the console for details."
		>
			<Bug color="#c0392b" size={40} strokeWidth={2} aria-hidden />
		</div>
	);
};
